import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function TelevisionPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center">
        <div className="absolute inset-0">
          <img 
            src="https://static.readdy.ai/image/ad65b144d099927d3f1598dca8778b1e/b92be90989d84055b04ceff6e352816c.png"
            alt="Television Hero"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        
        <div className="relative z-10 text-center px-6">
          <h1 className="text-5xl md:text-6xl font-light text-white tracking-tight">Television</h1>
        </div>
      </section>

      {/* Script Excerpt */}
      <section className="py-24 px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-semibold text-black mb-12 tracking-tight text-center">Television Drama</h2>
          
          <h3 className="text-4xl font-light text-black mb-8 tracking-tight text-center">Finding Joy</h3>
          
          <div className="bg-gray-50 p-8 mb-12 font-['Courier_New',_Courier,_monospace] shadow-[0_10px_40px_rgba(0,0,0,0.3)]">
            <p className="text-sm font-medium text-black mb-2 text-center">"Pilot"</p>
            <p className="text-sm font-medium text-black mb-6 text-center">TEASER</p>
            <p className="text-sm font-medium text-black mb-4">FADE IN:</p>
            
            <div className="space-y-6 text-sm text-gray-800 leading-relaxed">
              <div>
                <p className="font-medium text-black mb-2">EXT. NEW MEXICO - BEFORE DAWN</p>
                <p>Large red rock mesas and dirt...Lots and lots of dirt. Beautiful but desolate.</p>
                <p className="mt-2">A freeway. Alongside the freeway, a "Welcome to New Mexico" sign with red and green chilies.</p>
                <p className="mt-2">Along the base of a mesa runs railroad tracks. Something moves at the base of the mesa...</p>
              </div>

              <div>
                <p className="font-medium text-black mb-2">EXT. RAILROAD TRACKS - BEFORE DAWN</p>
                <p>...It is JADA, a Navajo teen, in a daze. She stumbles down the tracks. Jada has a "Moko Kauae," a Maori chin tattoo worn by women.</p>
                <p className="mt-2">She trips, kicking rocks into the metal rails. That CLUNKING noise morphs into another sound...</p>
              </div>

              <div>
                <p className="font-medium text-black mb-2">INT. ASHER WILLIAMS HOME OFFICE - BEFORE DAWN</p>
                <p>The CLUNK of a computer printer spitting out flyers.</p>
                <p className="mt-2">Watching the printer is ASHER WILLIAMS, blonde, former high school cheerleader now looking like a refugee with large sad eyes. White, female, 35.</p>
                <p className="mt-2">She's dressed in a blue shirt that says "Chief, Restless Pines, District 11, Volunteer Fire and Rescue."</p>
                <p className="mt-2">On the flyer is a picture of JOY WILLIAMS, Asher's daughter.</p>
                <p className="mt-2">Flyer reads, "MISSING since 2023. From New Mexico. Joy Williams, 15, 5'5", blond hair, shoulder length. Please call with any information, 505-555-0163."</p>
                <p className="mt-2">The photo of Joy shows a sweet faced girl with a smile that doesn't make it to her eyes.</p>
                <p className="mt-2">Ash pulls out a pocket watch and checks the time.</p>
                <p className="mt-2">The copier jams. Ash tries to clear it. Papers RIP.</p>
              </div>
            </div>
          </div>

          {/* Logline Section */}
          <div className="border-t border-gray-200 pt-12">
            <h4 className="text-lg font-medium text-black mb-4 tracking-wide">LOGLINE</h4>
            <p className="text-gray-700 text-base leading-relaxed mb-4">
              Set in and around the Navajo Reservation near Gallup, New Mexico, a motley group of volunteer fire fighters and EMTs, led by a female fire chief, deal with strange and bizarre emergency calls that reflect the region and the inhabitants, while trying to find happiness off duty in their personal lives. FINDING JOY is a drama for television.
            </p>
            <p className="text-sm text-gray-500 mb-8">© 2026 Pamela Stovall</p>
            <p className="text-gray-700 text-base leading-relaxed font-medium">
              FINDING JOY is currently under a shopping agreement with Bohemia Entertainment.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
